module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BQZcZX/tc-custom/9781956136159.jpg?1678299093941",
      "alt": "This image is the cover for the book Alex McKenna and Death is Not the Beginning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Alex McKenna and Death is Not the Beginning\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the fourth and final installment for the series, Alex faces his most difficult case yet: the school bully.")]), _vm._v(" "), _c('br'), _vm._v(" For two years, Kyle had no qualms making Alex's life even more complicated than it already was. "), _c('br'), _vm._v(" Choosing to single him out for his psychic abilities, the angry teen took every chance to undermine Alex's well-being. But When Kyle is unexpectedly murdered, his ghost seeks out Alex for the very power he'd been stigmatized for. "), _c('br'), _vm._v(" Despite their fraught history, Alex must set aside old wounds to help a soul in need. Searching for the killer, Alex uncovers why Kyle had victimized him so intensely, and it's not what he ever could have expected. The truth, it turns out, will set them both free. "), _c('br'), _c('br'), _vm._v(" The Alex McKenna Series in order: "), _c('br'), _vm._v(" Alex McKenna and the Geranium Deaths "), _c('br'), _vm._v(" Alex McKenna and the Academy of Souls "), _c('br'), _vm._v(" Alex McKenna and a Winter's Night "), _c('br'), _vm._v(" Alex McKenna and Death is Not the Beginning\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Vicki-Ann Bush\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Originally from New York, Vicki-Ann currently resides in Nevada. Writing Young Adult paranormal, she finds inspiration from events that have been in her life for as long as she can remember. Inheriting her sensitivity to the supernatural from her family, they continue to be an endless source of vision.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Parliament House Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0